import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=6eeadb88&scoped=true&lang=pug&"
import script from "./Classify.vue?vue&type=script&lang=ts&"
export * from "./Classify.vue?vue&type=script&lang=ts&"
import style0 from "./Classify.vue?vue&type=style&index=0&id=6eeadb88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeadb88",
  null
  
)

export default component.exports